import { View, ViewOpts } from '@play-co/timestep-core/ui';
import {
  getRescueLevelTheme,
  getRescueLevelThemeName,
} from '../rescueLevel.theme';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import gsap from 'gsap';

export class Instruction extends View {
  private content: View;
  private icon: View;
  private text: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      centerOnOrigin: true,
    });

    this.content = new View({
      superview: this,
    });

    this.icon = getRescueLevelTheme().getIconLarge({
      superview: this.content,
      y: -100,
    });

    this.text = new LangBitmapFontTextView({
      superview: this.content,
      align: 'center',
      verticalAlign: 'center',
      size: 42,
      font: 'Title',
      width: 800,
      height: 400,
      color: '#ffffff',
      centerOnOrigin: true,
      localeText: () =>
        i18n(`rescueLevel.${getRescueLevelThemeName()}.instruction`),
      y: 150,
    });
  }

  public updateOpts(opts: ViewOpts) {
    const result = super.updateOpts(opts);
    this.content.updateOpts({
      x: this.style.width / 2,
      y: this.style.height / 2,
    });
    return result;
  }

  public tick() {
    const time = performance.now();

    this.text.updateOpts({
      scale: 1 + Math.sin(time / 100) * 0.05,
    });

    this.icon.updateOpts({
      y: Math.sin(time / 200) * 10 - 100,
    });
  }

  public async hideAnimated() {
    this.onInputStart = undefined;
    this.updateOpts({
      canHandleEvents: false,
    });

    await gsap.to(this.content.style, {
      scale: 2,
      opacity: 0,
      duration: 0.3,
      ease: 'back.in',
    });

    await gsap.to(this.style, {
      opacity: 0,
      duration: 0.3,
      ease: 'sine.in',
    });

    this.hide();
  }
}
